import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { addListItem, getLibraryOption } from '@blade-sxp/its-management/api/detail';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    type;
    deviceId;
    addDeviceSuccess;
    changeType;
    formRef;
    // param!: devices;
    loading = false;
    direction = '';
    formData = {
        libType: '',
        libIds: [],
        deviceId: '',
    };
    Library = [];
    get subDisable() {
        const { libType, libIds } = this.formData;
        return !(libType.length > 0 && libIds.length > 0);
    }
    get rules() {
        return {
        // libType: [{ required: true, message: `${this.$t('distributedTypeHolder')}`, trigger: ['blur', 'change'] }],
        // libIds: [{ required: true, message: `${this.$t('libraryHolder')}`, trigger: ['blur', 'change'] }],
        };
    }
    get shouldDisable() {
        if (this.type === 'view') {
            return true;
        }
        else {
            return false;
        }
    }
    // libType 待选项
    get getdistributedType() {
        return [
            { text: String(this.$t('blackLibrary')), value: 'TrafficBlackList' },
            { text: String(this.$t('whiteLibaray')), value: 'TrafficRedList' },
        ];
    }
    // libType 待选项 -
    get getdistributedTypeWhite() {
        return [{ text: String(this.$t('whiteLibaray')), value: 'TrafficRedList' }];
    }
    // libId 待选项
    // get getLibrary() {
    //   return [];
    // }
    // dialog 标题
    get returnTitle() {
        if (this.type === 'edit') {
            return `${this.$t('editDevice')}`;
        }
        else if (this.type === 'view') {
            return `${this.$t('deviceDetails')}`;
        }
        else {
            return `${this.$t('deviceAdd')}`;
        }
    }
    mounted() {
        // this.getDevice();
        this.getLibraryAry();
        this.direction = this.$route.query.direction.toString();
    }
    getLibraryAry() {
        getLibraryOption({ libType: 'AUTO_MOBILE' }).then((res) => {
            this.Library = res.list;
        });
    }
    // 提交form表单
    handleSubmit() {
        this.formRef?.validate().then((res) => {
            // console.log(res);
            // 提交逻辑
            this.addListItem();
        });
    }
    handleClose() {
        this.$emit('update:dialogVisible', false);
    }
    addListItem() {
        this.loading = true;
        try {
            const deviceId = this.$route.query.deviceId.toString();
            const { libType, libIds } = this.formData;
            this.formData = { deviceId, libType, libIds };
            addListItem(this.formData)
                .then(() => {
                this.$elmessage.success(`${this.$t('successAdd').toString()}`);
                // this.handleClose();
                this.$emit('update:dialogVisible', false);
                this.$emit('success');
            })
                .catch(() => {
                this.loading = false;
            })
                .finally(() => {
                this.loading = false;
            });
        }
        catch (error) {
            console.log('addListItem err', error);
            this.loading = false;
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceId", void 0);
__decorate([
    Prop()
], default_1.prototype, "addDeviceSuccess", void 0);
__decorate([
    Prop()
], default_1.prototype, "changeType", void 0);
__decorate([
    Ref()
], default_1.prototype, "formRef", void 0);
default_1 = __decorate([
    Component({
        name: 'model',
        components: {},
        i18n: {
            messages: {
                en: {
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    deviceAdd: 'Add Device',
                    deviceAddSuccess: 'Add Device Success',
                    editDevice: 'Edit Device',
                    deviceDetails: 'Device Details',
                    libType: 'Distributed Type',
                    distributedTypeHolder: 'please select',
                    libId: 'Vehicle Library Name',
                    libraryHolder: 'please select',
                    successAdd: 'Add Success',
                    blackLibrary: 'Black Library',
                    whiteLibaray: 'White Library',
                },
                zh: {
                    confirm: '确定',
                    cancel: '取消',
                    deviceAdd: '添加设备',
                    deviceAddSuccess: '添加设备成功',
                    editDevice: '设备编辑',
                    deviceDetails: '请选项',
                    libType: '分布类型',
                    distributedTypeHolder: '请选择分布类型',
                    libId: '车库名称',
                    libraryHolder: '请选择车库名称',
                    successAdd: '添加成功',
                    blackLibrary: '黑名单',
                    whiteLibaray: '白名单',
                },
            },
        },
    })
], default_1);
export default default_1;
